import type { SVGProps } from "react";

/**
 * The page's one recurring graphic motif: a thin curved line tracing
 * Road → Billboard → Brand → Customer. Used sparingly as a quiet
 * background accent, never as a literal diagram.
 */
export function MotifLine(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 600 120" fill="none" aria-hidden="true" {...props}>
      <path
        d="M0 100C120 100 140 20 260 20S380 90 470 60 560 15 600 15"
        stroke="var(--color-blue-500)"
        strokeWidth="1.4"
        opacity="0.5"
      />
      <circle cx="260" cy="20" r="3.5" fill="var(--accent)" />
    </svg>
  );
}
